Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOpaqueColor = void 0;
var getOpaqueColor = exports.getOpaqueColor = function getOpaqueColor(value, opacity) {
  var _hexOpacity = parseInt((opacity * 100).toString(), 16);
  return "".concat(value).concat(_hexOpacity);
};